<div class="pageContent">
  <div class="pageTitle">
    <h2>Banco de Procesos</h2>
  </div>
  <app-data-table
    tableId="datatableBancoProcesos"
    [serverSide]="true"
    [serverData]="getDataTableCatalogProcess"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<app-modal-notify #crearModal></app-modal-notify>

<!-- Modal para Ver Diagrama del proceso del catálogo (reutiliza app-generic-modal + app-diagram-viewer) -->
<app-generic-modal
  [isVisible]="modalDiagramaVisible"
  [title]="'Proceso ' + idCatalogProcessTitle + ' - ' + nombreCatalogProcessTitle"
  [showLoading]="!mostrarDiagrama"
  loadingMessage="Cargando diagrama..."
  (closeModal)="cerrarModalDiagrama()">
  <app-diagram-viewer
    *ngIf="mostrarDiagrama"
    [xmlContent]="xmlContent"
    [readOnly]="true"
    [showTooltips]="false"
    [showLegend]="false"
    [hideWatermark]="true">
  </app-diagram-viewer>
</app-generic-modal>

